import React from "react";

export default function TermsConditions() {
  return (
    <section className="bg-gray-50 py-16 pt-20">
      <div className="max-w-7xl mx-auto px-6">

        {/* Page Header */}
        <div className="text-center max-w-4xl mx-auto">
          <h1 className="text-h1 font-bold text-trogoBlue">
            Terms & Conditions
          </h1>
          <p className="text-gray-600 mt-3">
            Welcome to TROGO. By accessing or using our platform, you agree
            to the following Terms and Conditions. Please read them carefully.
          </p>
        </div>

        {/* Section 1 */}
        <div className="mt-12 bg-white p-8 rounded-3xl shadow border">
          <h2 className="text-2xl font-bold text-trogoOrange">
            1. Acceptance of Terms
          </h2>
          <p className="text-gray-700 mt-3 leading-relaxed">
            By registering, accessing, or using the TROGO Application or Website,
            you acknowledge that you have read, understood, and agree to comply
            with these Terms & Conditions along with our Privacy Policy.
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid md:grid-cols-2 gap-10 mt-12">

          {/* Eligibility */}
          <div className="bg-white p-8 shadow rounded-3xl border">
            <h3 className="text-xl font-bold text-trogoBlue">
              2. User Eligibility
            </h3>
            <p className="text-gray-700 mt-3">
              Users must be:
            </p>
            <ul className="list-disc pl-6 mt-2 text-gray-700 space-y-1">
              <li>18+ years of age</li>
              <li>Legally capable of entering binding agreements</li>
              <li>Providing accurate and valid information</li>
            </ul>
          </div>

          {/* Platform Use */}
          <div className="bg-white p-8 shadow rounded-3xl border">
            <h3 className="text-xl font-bold text-trogoBlue">
              3. Platform Usage
            </h3>
            <p className="text-gray-700 mt-3">
              Users agree to use TROGO only for legitimate purposes, including:
            </p>
            <ul className="list-disc pl-6 mt-2 text-gray-700 space-y-1">
              <li>Passenger Transport</li>
              <li>Goods Transport</li>
              <li>Heavy Vehicles Services</li>
            </ul>
          </div>

          {/* Driver & Vehicle Policy */}
          <div className="bg-white p-8 shadow rounded-3xl border">
            <h3 className="text-xl font-bold text-trogoBlue">
              4. Driver & Vehicle Compliance
            </h3>
            <p className="text-gray-700 mt-3">
              TROGO ensures that:
            </p>
            <ul className="list-disc pl-6 mt-2 text-gray-700 space-y-1">
              <li>Drivers are verified & authorized</li>
              <li>Vehicles are registered & approved</li>
              <li>Safety & service standards are followed</li>
            </ul>
          </div>

          {/* Data & Security */}
          <div className="bg-white p-8 shadow rounded-3xl border">
            <h3 className="text-xl font-bold text-trogoBlue">
              5. Data Privacy & Security
            </h3>
            <p className="text-gray-700 mt-3">
              User data is collected strictly for service purposes.
              TROGO does not share sensitive information with
              unauthorized third parties.
            </p>
            <p className="text-gray-600 mt-2">
              Refer to our Privacy Policy for more details.
            </p>
          </div>

          {/* Payment & Charges */}
          <div className="bg-white p-8 shadow rounded-3xl border">
            <h3 className="text-xl font-bold text-trogoBlue">
              6. Payments & Charges
            </h3>
            <p className="text-gray-700 mt-3">
              Service charges, subscription fees (if applicable),
              and payment policies will be clearly displayed within
              the application.
            </p>
          </div>

          {/* Prohibited Activities */}
          <div className="bg-white p-8 shadow rounded-3xl border">
            <h3 className="text-xl font-bold text-trogoBlue">
              7. Prohibited Activities
            </h3>
            <ul className="list-disc pl-6 mt-3 text-gray-700 space-y-1">
              <li>Fraudulent activities</li>
              <li>Misuse of platform</li>
              <li>Harassment or abuse</li>
              <li>Illegal transport activities</li>
            </ul>
          </div>
        </div>

        {/* Liability Section */}
        <div className="mt-12 bg-white p-8 rounded-3xl shadow border">
          <h2 className="text-2xl font-bold text-trogoOrange">
            8. Limitation of Liability
          </h2>
          <p className="text-gray-700 mt-3 leading-relaxed">
            TROGO is not responsible for losses due to user negligence,
            false information, third-party actions, or misuse of platform services.
          </p>
        </div>

        {/* Termination */}
        <div className="mt-10 bg-white p-8 rounded-3xl shadow border">
          <h2 className="text-2xl font-bold text-trogoOrange">
            9. Account Suspension / Termination
          </h2>
          <p className="text-gray-700 mt-3">
            TROGO reserves the right to suspend or terminate accounts
            violating company policies or legal guidelines.
          </p>
        </div>

        {/* Legal */}
        <div className="mt-10 bg-white p-8 rounded-3xl shadow border">
          <h2 className="text-2xl font-bold text-trogoOrange">
            10. Governing Law
          </h2>
          <p className="text-gray-700 mt-3">
            These Terms & Conditions are governed under the
            **Laws of India** and applicable Indian Penal Code regulations.
          </p>
        </div>

        {/* Footer Note */}
        <div className="mt-14 bg-gradient-to-r from-trogoBlue to-trogoOrange text-white p-10 rounded-3xl shadow-lg text-center">
          <h3 className="text-2xl font-bold">Thank You for Trusting TROGO</h3>
          <p className="mt-3 opacity-90">
            By continuing to use our services, you agree to maintain
            safety, trust, and respect within the TROGO platform.
          </p>
        </div>

      </div>
    </section>
  );
}
